var _defs, _clipPath, _defs2, _clipPath2, _defs3, _mask, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBenefitEdenred(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148,
    height: 50,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.1 0H148v50H.1z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.1 0h148.3v50H.1z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse",
    x: 66.1,
    y: 0.1,
    width: 82.3,
    height: 49.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 66.1,
    y: 0.1,
    width: 82.3,
    height: 49.9,
    id: "f"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M148.3 0H.2v50h148.2V0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3 21.7c-1.5 0-2.4.9-2.7 2.2h5.2c-.2-1.4-1.2-2.2-2.5-2.2zM83.3 22.3c-1.9 0-3 1.3-3 3s1.2 3.1 3 3.1 3.1-1.3 3.1-3.1-1.2-3-3.1-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 19.4c-2.8 0-5 1.1-5.3 4-.9-13-11.3-23.3-24.6-23.3-10.3 0-19.5 6.1-23.4 15.5h8.9l-.5 3h-7v3.2h6.4l-.5 2.9h-5.9v1.8c0 1.1.5 1.6 1.4 1.6h6l-.5 3h-6.6c-.3 0-.6 0-.9-.1-.7-.1-1.4-.5-1.9-1-.2-.3-.4-.6-.5-.9l-.1-.3c0 .4.1.9.2 1 .2 1 .5 1.9.5 2C70.5 45 84.5 52.7 98 49c8.7-2.4 15.4-9.3 17.6-17.9h-3.4V25c0-1.6-.6-2.7-2.3-2.7s-2.3 1-2.3 2.7v6h-3.4v-6.9c0-3.3 2.4-4.8 5.7-4.8s5.7 1.5 5.7 4.8V31h3.4v-6.1c0-1.6.5-2.7 2.1-2.7.5 0 .9.1 1.4.3l.6-2.9c-.7-.1-1.4-.2-2.1-.2zm-31.2 5.2c0 4.2-2.5 6.6-6.6 6.6-3.8 0-6.4-2.5-6.4-6 0-3.6 2.5-6 6.1-6 1.7 0 2.9.7 3.6 1.3v-5.1h3.4l-.1 9.2zm8.6 4.2c1 0 1.9-.3 2.8-.7l-.3 2.6c-1.1.4-2.2.6-3.3.6-3.9 0-6.7-2.3-6.7-6.1 0-3.3 2.5-5.8 6.2-5.8 4.3 0 6.4 2.7 6.3 6.8h-8.8c.4 1.8 2.3 2.6 3.8 2.6zM128.7 19.4c-3.8 0-6.2 2.5-6.2 5.8 0 3.8 2.8 6.1 6.6 6.1 1.1 0 2.3-.1 3.3-.6l.3-2.6c-.9.4-1.8.7-2.8.7-1.6 0-3.4-.7-3.7-2.6h8.8c.1-4.2-2.1-6.8-6.3-6.8zm-2.6 4.5c.3-1.3 1.2-2.2 2.7-2.2 1.4 0 2.4.8 2.5 2.2h-5.2zM145 15.6v5.1c-.6-.7-1.9-1.3-3.6-1.3-3.7 0-6.1 2.4-6.1 6 0 3.4 2.6 6 6.4 6 4.1 0 6.6-2.5 6.6-6.6v-9.1H145zm-3.1 12.8c-1.8 0-3-1.3-3-3.1 0-1.7 1.2-3 3-3 1.9 0 3.1 1.2 3.1 3s-1.2 3.1-3.1 3.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.1 17.4h5.8c2.6 0 3.9 1.1 3.9 3.3 0 .6-.1 1.3-.5 1.8-.3.5-.8.8-1.4.9.9.1 1.6.5 2 1 .5.6.7 1.4.6 2.2 0 2.5-1.4 3.7-4.3 3.7H3.3c-1 0-1.8-.3-2.4-.8-.6-.6-.8-1.3-.8-2.2v-9.9zm2.2 1.9v2.4c0 .3.1.7.3.9.3.3.6.4 1 .3h1.5c1.4 0 2.2-.6 2.2-1.9 0-.7-.2-1.2-.5-1.4-.4-.3-.9-.4-1.6-.4H2.3zm0 4.4v3.5c0 .9.5 1.3 1.5 1.3h2.1c1.5 0 2.2-.7 2.2-2 0-.7-.2-1.2-.5-1.5-.3-.3-.9-.4-1.6-.4H3.7c-.3 0-.6 0-.9-.2-.2-.2-.4-.4-.5-.7zM19.4 28.4l-.2 1.7c-.8.3-1.6.5-2.4.4-1.6 0-2.8-.5-3.8-1.4-1-.9-1.5-2.2-1.5-3.7 0-1.4.5-2.6 1.4-3.5.9-.9 2.2-1.4 3.6-1.4 1.6 0 2.8.5 3.7 1.5.9 1 1.3 2.3 1.3 3.9h-7.8c.1 1 .5 1.7 1.1 2.2.7.5 1.5.8 2.4.7.8.1 1.5 0 2.2-.4zm-.9-5.6c-.5-.4-1.2-.6-1.8-.6-.7 0-1.4.2-1.9.6-.5.4-.9 1-1 1.7h5.6c-.1-.7-.4-1.3-.9-1.7zM29.7 30.4v-5.5c0-.8-.2-1.4-.6-1.8-.4-.4-1-.6-1.7-.6-.8 0-1.3.2-1.7.6-.4.4-.6 1-.6 1.8v5.5H23v-5.9c0-1.3.4-2.2 1.2-2.9.8-.7 1.9-1 3.2-1 1.4 0 2.4.3 3.2 1 .8.7 1.2 1.6 1.2 2.9v5.9h-2.1zM41 28.4l-.2 1.7c-.8.3-1.6.5-2.4.4-1.6 0-2.8-.5-3.8-1.4-1-.9-1.5-2.2-1.5-3.7 0-1.4.5-2.6 1.4-3.5.9-.9 2.2-1.4 3.6-1.4 1.6 0 2.8.5 3.7 1.5.9 1 1.3 2.3 1.3 3.9h-7.8c.1 1 .5 1.7 1.1 2.2.7.5 1.5.7 2.4.7.8.1 1.6 0 2.2-.4zm-.9-5.6c-.5-.4-1.2-.6-1.8-.6-.7 0-1.4.2-1.9.6-.5.4-.9 1-1 1.7H41c-.1-.7-.4-1.3-.9-1.7zM46.7 30.4h-2.1v-9.8c0-1 .3-1.9.9-2.4.6-.6 1.4-.9 2.5-.9.6 0 1.1.1 1.7.2l-.3 1.5c-.3-.1-.7-.2-1.1-.2-1.1 0-1.6.5-1.6 1.4v.5h2.5l-.2 1.7h-2.2l-.1 8zM53.3 17.4h-2.1v1.8h2.1v-1.8zM53.3 20.7h-2.1v9.7h2.1v-9.7zM55.2 25.5v-7.2l2.1-.8v3.3h2l-.3 1.6h-1.7v3.2c0 1.5.6 3.1 1.8 4.7l.1.2h-2.3l-.2-.3c-.1-.2-.2-.3-.3-.4l-.3-.4-.3-.6c-.1-.1-.2-.4-.2-.6-.1-.3-.2-.5-.2-.8 0-.2-.1-.5-.1-.8-.1-.5-.1-.8-.1-1.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: -0.914,
    y1: 30.512,
    x2: 53.425,
    y2: 7.184,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8e4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#f60052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#9438a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#5b58d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0086e0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M.1 17.4h5.8c2.6 0 3.9 1.1 3.9 3.3 0 .6-.1 1.3-.5 1.8-.3.5-.8.8-1.4.9.9.1 1.6.5 2 1 .5.6.7 1.4.6 2.2 0 2.5-1.4 3.7-4.3 3.7H3.3c-1 0-1.8-.3-2.4-.8-.6-.6-.8-1.3-.8-2.2v-9.9zm2.2 1.9v2.4c0 .3.1.7.3.9.3.3.6.4 1 .3h1.5c1.4 0 2.2-.6 2.2-1.9 0-.7-.2-1.2-.5-1.4-.4-.3-.9-.4-1.6-.4H2.3zm0 4.4v3.5c0 .9.5 1.3 1.5 1.3h2.1c1.5 0 2.2-.7 2.2-2 0-.7-.2-1.2-.5-1.5-.3-.3-.9-.4-1.6-.4H3.7c-.3 0-.6 0-.9-.2-.2-.2-.4-.4-.5-.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 0.341,
    y1: 33.435,
    x2: 54.685,
    y2: 10.104,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8e4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#f60052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#9438a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#5b58d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0086e0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m19.4 28.4-.2 1.7c-.8.3-1.6.5-2.4.4-1.6 0-2.8-.5-3.8-1.4-1-.9-1.5-2.2-1.5-3.7 0-1.4.5-2.6 1.4-3.5.9-.9 2.2-1.4 3.6-1.4 1.6 0 2.8.5 3.7 1.5.9 1 1.3 2.3 1.3 3.9h-7.8c.1 1 .5 1.7 1.1 2.2.7.5 1.5.8 2.4.7.8.1 1.5 0 2.2-.4zm-.9-5.6c-.5-.4-1.2-.6-1.8-.6-.7 0-1.4.2-1.9.6-.5.4-.9 1-1 1.7h5.6c-.1-.7-.4-1.3-.9-1.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 1.785,
    y1: 36.8,
    x2: 56.124,
    y2: 13.473,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8e4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#f60052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#9438a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#5b58d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0086e0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M29.7 30.4v-5.5c0-.8-.2-1.4-.6-1.8-.4-.4-1-.6-1.7-.6-.8 0-1.3.2-1.7.6-.4.4-.6 1-.6 1.8v5.5H23v-5.9c0-1.3.4-2.2 1.2-2.9.8-.7 1.9-1 3.2-1 1.4 0 2.4.3 3.2 1 .8.7 1.2 1.6 1.2 2.9v5.9h-2.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 3.709,
    y1: 41.28,
    x2: 58.054,
    y2: 17.95,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8e4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#f60052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#9438a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#5b58d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0086e0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m41 28.4-.2 1.7c-.8.3-1.6.5-2.4.4-1.6 0-2.8-.5-3.8-1.4-1-.9-1.5-2.2-1.5-3.7 0-1.4.5-2.6 1.4-3.5.9-.9 2.2-1.4 3.6-1.4 1.6 0 2.8.5 3.7 1.5.9 1 1.3 2.3 1.3 3.9h-7.8c.1 1 .5 1.7 1.1 2.2.7.5 1.5.7 2.4.7.8.1 1.6 0 2.2-.4zm-.9-5.6c-.5-.4-1.2-.6-1.8-.6-.7 0-1.4.2-1.9.6-.5.4-.9 1-1 1.7H41c-.1-.7-.4-1.3-.9-1.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 5.677,
    y1: 45.867,
    x2: 60.016,
    y2: 22.539,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8e4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#f60052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#9438a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#5b58d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0086e0"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M46.7 30.4h-2.1v-9.8c0-1 .3-1.9.9-2.4.6-.6 1.4-.9 2.5-.9.6 0 1.1.1 1.7.2l-.3 1.5c-.3-.1-.7-.2-1.1-.2-1.1 0-1.6.5-1.6 1.4v.5h2.5l-.2 1.7h-2.2l-.1 8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 8.508,
    y1: 52.459,
    x2: 62.847,
    y2: 29.132,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8e4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#f60052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#9438a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#5b58d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0086e0"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M53.3 17.4h-2.1v1.8h2.1v-1.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 5.885,
    y1: 46.349,
    x2: 60.224,
    y2: 23.022,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8e4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#f60052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#9438a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#5b58d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0086e0"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M53.3 20.7h-2.1v9.7h2.1v-9.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 7.228,
    y1: 49.478,
    x2: 61.566,
    y2: 26.151,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8e4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#f60052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#9438a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#5b58d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0086e0"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M55.2 25.5v-7.2l2.1-.8v3.3h2l-.3 1.6h-1.7v3.2c0 1.5.6 3.1 1.8 4.7l.1.2h-2.3l-.2-.3c-.1-.2-.2-.3-.3-.4l-.3-.4-.3-.6c-.1-.1-.2-.4-.2-.6-.1-.3-.2-.5-.2-.8 0-.2-.1-.5-.1-.8-.1-.5-.1-.8-.1-1.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBenefitEdenred);
export default __webpack_public_path__ + "static/media/Logo-Benefit-Edenred.02ab49454bd61149e5e60da5b04f98d4.svg";
export { ForwardRef as ReactComponent };